import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';
import * as Company from './Company';
import * as Ticket from './Ticket';
import * as User from './User';

export type BaseView = {
  '@id': string;
  '@type': 'WorkDone';
  id: string;
  minutes: number | null;
  loggedAt: string | null;
  loggingStartedAt: string | null;
  categoryString: string | null;
};

export type V_List = BaseView & {
  company: Company.BaseView | null;
  project: {
    '@id': string;
    '@type': 'Project';
    id: string;
    company: Company.BaseView;
    name: string;
    createdAt: string;
    archivedAt: string | null;
  } | null;
  serviceOrder: {
    '@id': string;
    '@type': 'ServiceOrder';
    id: string;
    company: Company.BaseView;
    name: string;
    referenceNumber: string | null;
    budget: number | null;
    dayLimit: string | null;
    finishDate: string | null;
  } | null;
  ticket:
    | (Ticket.BaseView & {
        company: Company.BaseView;
      })
    | null;
  user: User.BaseView;
};

export type V_Timer = BaseView & {
  company: Company.BaseView | null;
  project: {
    '@id': string;
    '@type': 'Project';
    id: string;
    company: Company.BaseView;
    name: string;
    createdAt: string;
    archivedAt: string | null;
  } | null;
  serviceOrder: {
    '@id': string;
    '@type': 'ServiceOrder';
    id: string;
    company: Company.BaseView;
    name: string;
    referenceNumber: string | null;
    budget: number | null;
    dayLimit: string | null;
    finishDate: string | null;
  } | null;
  ticket:
    | (Ticket.BaseView & {
        company: Company.BaseView;
      })
    | null;
};

export type W = {
  company: string | null;
  project: string | null;
  serviceOrder: string | null;
  ticket: string | null;
  task: string | null;
  user: string;
  minutes: number | null;
  loggedAt: string | null;
  categoryString: string | null;
};

export type W_Start = {
  company: string | null;
  project: string | null;
  serviceOrder: string | null;
  ticket: string | null;
  task: string | null;
  categoryString: string | null;
};

export function useReadCollection(
  queryParams?: {
    company?: string;
    'company[]'?: Array<string>;
    'loggedAt[after]'?: string;
    'loggedAt[before]'?: string;
    'loggedAt[strictly_after]'?: string;
    'loggedAt[strictly_before]'?: string;
    'ticket.company'?: string;
    'ticket.company[]'?: Array<string>;
  },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V_List>>(
    `/work-dones${makeQueryString(queryParams)}`,
    options
  );
}

export function useReadCollectionRecent(
  queryParams?: {
    'loggedAt[after]'?: string;
    'loggedAt[before]'?: string;
    'loggedAt[strictly_after]'?: string;
    'loggedAt[strictly_before]'?: string;
  },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V_Timer>>(
    `/work-dones/recent${makeQueryString(queryParams)}`,
    options
  );
}

export function useReadCollectionUsersSub(
  userId: string,
  queryParams?: {
    'loggedAt[after]'?: string;
    'loggedAt[before]'?: string;
    'loggedAt[strictly_after]'?: string;
    'loggedAt[strictly_before]'?: string;
  },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V_List>>(
    `/users/${userId}/work-dones${makeQueryString(queryParams)}`,
    options
  );
}
